import {Component, Inject, ViewEncapsulation, ChangeDetectionStrategy} from '@angular/core';
import {RadioModalData, RadioModalDataType} from "@portal/shared/models/radio-modal-data";
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent, MatDialogActions, MatDialogClose } from "@angular/material/dialog";
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-activity-report-modal',
    templateUrl: './activity-report-modal.component.html',
    styleUrls: ['./activity-report-modal.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CdkScrollable, MatDialogContent, MatRadioGroup, FormsModule, MatRadioButton, MatCheckbox, MatDialogActions, MatButton, MatDialogClose]
})
export class ActivityReportModalComponent {
    selectedOption: number = 1;
    selectedOptions: number[] = [];

    constructor(
        public dialogRef: MatDialogRef<ActivityReportModalComponent>) {
    }

    confirmSelection() {
        let result = {};
        result = { ...result, selectedOptions: this.selectedOptions, selectedOption: this.selectedOption };
        this.dialogRef.close(result);
    }

    onCheckboxChange(option: number, isChecked: boolean) {
        if (isChecked) {
            if (!this.selectedOptions.includes(option)) {
                this.selectedOptions.push(option);
            }
        } else {
            const index = this.selectedOptions.indexOf(option);
            if (index !== -1) {
                this.selectedOptions.splice(index, 1);
            }
        }
    }
}
